module.exports = __webpack_public_path__ + "img/call-icon.9d3d5d60.svg";